module.exports = __webpack_public_path__ + "static/media/bagel_line.b91ac992.svg";